document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
    const links = [...tabs.querySelectorAll('[role="tab"]')];
    const panels = [...tabs.querySelectorAll('[role="tabpanel"]')];

    const activate = (link, moveFocus = false) => {
      const targetId = link.getAttribute('aria-controls');
      links.forEach((item) => {
        const selected = item === link;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        item.closest('li')?.classList.toggle('ui-tabs-active', selected);
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });
      if (moveFocus) link.focus();
    };

    links.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        activate(link);
      });
      link.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + links.length) % links.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % links.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = links.length - 1;
        activate(links[nextIndex], true);
      });
    });

    if (links[0]) activate(links[0]);
  });
});
